import posthog from 'posthog-js';
import { baseConfig } from 'src/config';
import { selectSpaceFromUser } from 'src/hooks/useSpace';
import { User } from 'src/models/user.interface';

type EventType = string;

interface CaptureEventProps {
  eventType: EventType;
  event?: Record<string, unknown>;
}

export class PosthogAnalytics {
  static captureEvent = ({ eventType, event }: CaptureEventProps) => {
    if (process.env.NODE_ENV !== 'production') return;
    posthog.capture(eventType, event);
  };

  static identifyUser = (user: User) => {
    const { _id: userId, email } = user;

    if (!user.workspaces.length) {
      posthog.identify(userId, {
        email,
        releaseSHA: baseConfig.RELEASE_SHA
      });

      return;
    }
    const space = selectSpaceFromUser(user);

    if (!space || space.spaceType !== 'workspace') {
      posthog.identify(userId, {
        email,
        releaseSHA: baseConfig.RELEASE_SHA
      });

      return;
    }

    const {
      _id: workspaceId,
      name: workspaceName,
      member: { roles, state: memberState }
    } = space;

    posthog.identify(userId, {
      email,
      workspaceId,
      workspaceName,
      role: roles.join(', '),
      memberState,
      releaseSHA: baseConfig.RELEASE_SHA
    });
  };

  static initialise = () => {
    const host = baseConfig.POSTHOG_ANALYTICS_HOST;
    const token = baseConfig.POSTHOG_ANALYTICS_TOKEN_DASHBOARD;

    if (!token) throw new Error('Analytics token not included in env');
    if (!host) throw new Error('Analytics host url not included in env');

    return posthog.init(token, {
      api_host: host
    });
  };

  static updateUser = ({ workspaceId, workspaceName }) => {
    if (process.env.NODE_ENV !== 'production') return;

    if (workspaceId) {
      posthog.people.set({ workspaceId });
    }
    if (workspaceName) {
      posthog.people.set({ workspaceName });
    }
  };
}
